// src/components/layout/Footer.js
import React from 'react';
import { Code, Github, Linkedin, Twitter, Heart, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-scroll';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../data/translations';

const Footer = () => {
  const { darkMode } = useTheme();
  const { language } = useLanguage();
  const t = translations[language];
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className={`py-12 ${darkMode ? 'bg-gray-900' : 'bg-gray-800'} text-white`}>
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-8 md:mb-0">
            <div className="flex items-center mb-4">
              <Code className="h-6 w-6 text-blue-400 mr-2" />
              <span className="font-bold text-xl">Igor Sibemou</span>
            </div>
            <p className="text-gray-400 max-w-md mb-6">
              {language === 'fr' 
                ? "Développeur Full Stack passionné par le développement de solutions innovantes et performantes avec Spring Boot, React JS, et React Native."
                : "Full Stack Developer passionate about developing innovative and high-performance solutions with Spring Boot, React JS, and React Native."}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://github.com/igorvannel" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition-colors duration-200"
                aria-label="Github"
              >
                <Github className="h-5 w-5" />
              </a>
              
              <a 
                href="https://www.linkedin.com/in/igor-vannel-sibemou-tientcheu-353911294/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              
              <a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h5 className="text-lg font-semibold mb-4">{t["footer.menu"]}</h5>
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="accueil" 
                    spy={true} 
                    smooth={true} 
                    offset={-70} 
                    duration={500}
                    className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t["nav.home"]}
                  </Link>
                </li>
                <li>
                  <Link 
                    to="about" 
                    spy={true} 
                    smooth={true} 
                    offset={-70} 
                    duration={500}
                    className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t["nav.about"]}
                  </Link>
                </li>
                <li>
                  <Link 
                    to="competences" 
                    spy={true} 
                    smooth={true} 
                    offset={-70} 
                    duration={500}
                    className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t["nav.skills"]}
                  </Link>
                </li>
                <li>
                  <Link 
                    to="projets" 
                    spy={true} 
                    smooth={true} 
                    offset={-70} 
                    duration={500}
                    className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t["nav.projects"]}
                  </Link>
                </li>
                <li>
                  <Link 
                    to="parcours" 
                    spy={true} 
                    smooth={true} 
                    offset={-70} 
                    duration={500}
                    className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t["nav.experience"]}
                  </Link>
                </li>
                <li>
                  <Link 
                    to="contact" 
                    spy={true} 
                    smooth={true} 
                    offset={-70} 
                    duration={500}
                    className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t["nav.contact"]}
                  </Link>
                </li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-lg font-semibold mb-4">{t["footer.services"]}</h5>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {t["footer.webDev"]}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {t["footer.mobileDev"]}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {t["footer.apiDev"]}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {t["footer.microservices"]}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {t["footer.devops"]}
                  </a>
                </li>
              </ul>
            </div>
            
            <div className="col-span-2 md:col-span-1">
              <h5 className="text-lg font-semibold mb-4">{t["nav.contact"]}</h5>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-400">
                  <MapPin className="w-4 h-4 mr-2" />
                  Yaoundé, Cameroun
                </li>
                <li className="flex items-center text-gray-400">
                  <Phone className="w-4 h-4 mr-2" />
                  +237 657 13 11 93
                </li>
                <li className="flex items-center text-gray-400">
                  <Mail className="w-4 h-4 mr-2" />
                  sibpro61@gmail.com
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} Igor Sibemou. {t["footer.rights"]}
          </p>
          <p className="text-gray-400 text-sm flex items-center">
            {t["footer.madeWith"]} <Heart className="h-4 w-4 mx-1 text-red-500" /> {t["footer.and"]} React
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;